var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38.314,
    height: 38.084,
    viewBox: "0 0 38.314 38.084",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "fb",
    d: "M77.1.46a19.16,19.16,0,0,0-2.992,38.084V25.155H69.245V19.617h4.865V15.4c0-4.8,2.859-7.454,7.235-7.454a29.4,29.4,0,0,1,4.288.375v4.714H83.219c-2.381,0-3.121,1.478-3.121,2.992v3.593H85.41l-.849,5.538H80.1V38.544A19.16,19.16,0,0,0,77.1.46",
    transform: "translate(-57.946 -0.46)",
    fill: "#2ca17f"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFb);
export default __webpack_public_path__ + "static/media/fb.ec1956fcac843e91983030ef745ef4ab.svg";
export { ForwardRef as ReactComponent };